import { Injectable } from '@angular/core';
import { LogLevel } from '../models/log-level ';
import { ApiRequestModel } from '../interfaces/api-request-model';
import { LoggingGroupModel, LoggingModel } from '../models/logging-model';
import { ApiResponseWithputPagingSingle } from '../dashboard/models/api-response-table';
import { Guid } from './guid';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  logLevel: LogLevel = new LogLevel();

  public infoMessages: LoggingModel[] = [];
  public infoJsonMessages: LoggingModel[] = [];
  public warningMessages: LoggingModel[] = [];
  public warningJsonMessages: LoggingModel[] = [];
  public errorMessages: LoggingModel[] = [];
  public errorJsonMessages: LoggingModel[] = [];
  public backendErrorMessages: LoggingGroupModel[] = [];
  public backendWarningMessages: LoggingGroupModel[] = [];
  public backendInfoMessages: LoggingGroupModel[] = [];

  constructor(private guid: Guid, private translate: TranslateService) {}

  public addInfo(msg: any, isJson: boolean): void {
    const id = this.guid.NewGuid();
    if (isJson) {
      this.infoJsonMessages.push(new LoggingModel(id, msg));
    } else {
      this.infoMessages.push(new LoggingModel(id, msg));
    }
    this.logWith(this.logLevel.Info, msg);

    setTimeout(() => {
      this.deleteItemInfo(id);
    }, 15 * 1000);
  }

  public addLog(msg: string, level: any): void {
    this.logWith(level, msg);
  }

  public addWarning(msg: any, isJson: boolean): void {
    const id = this.guid.NewGuid();
    if (isJson) {
      this.warningJsonMessages.push(new LoggingModel(id, msg));
    } else {
      this.warningMessages.push(new LoggingModel(id, msg));
    }
    this.logWith(this.logLevel.Warn, msg);

    setTimeout(() => {
      this.deleteItemWarning(id);
    }, 30 * 1000);
  }

  public addError(msg: any, isJson: boolean): void {
    const id = this.guid.NewGuid();
    if (isJson) {
      this.errorJsonMessages.push(new LoggingModel(id, msg));
    } else {
      this.errorMessages.push(new LoggingModel(id, msg));
    }
    this.logWith(this.logLevel.Error, msg);
    setTimeout(() => {
      this.deleteItemError(id);
    }, 60 * 1000);
  }

  public addClientException(error: any, methodName: string) {
    const errorMessage = this.translate
      .instant('Error_Method')
      .replace('{0}', methodName);

    this.logWith(this.logLevel.Error, error);
  }

  public addListError(messages: string[]) {
    const id = this.guid.NewGuid();
    let finalMessage: LoggingGroupModel = new LoggingGroupModel(id, []);
    messages.forEach((element) => {
      finalMessage.messages.push(`> ` + element + `\r\n`);
    });

    this.backendErrorMessages.push(finalMessage);

    setTimeout(() => {
      const index = this.backendErrorMessages.findIndex(
        (current) => current.id == id
      );
      this.backendErrorMessages.splice(index, 1);
    }, 60 * 1000);
  }

  public addListWarning(messages: string[]) {
    const id = this.guid.NewGuid();
    let finalMessage: LoggingGroupModel = new LoggingGroupModel(id, []);
    messages.forEach((element) => {
      finalMessage.messages.push(`> ` + element + `\r\n`);
    });

    this.backendWarningMessages.push(finalMessage);

    setTimeout(() => {
      const index = this.backendWarningMessages.findIndex(
        (current) => current.id == id
      );
      this.backendWarningMessages.splice(index, 1);
    }, 30 * 1000);
  }

  public addListInfo(messages: string[]) {
    const id = this.guid.NewGuid();
    let finalMessage: LoggingGroupModel = new LoggingGroupModel(id, []);
    messages.forEach((element) => {
      finalMessage.messages.push(`> ` + element + `\r\n`);
    });

    this.backendInfoMessages.push(finalMessage);

    setTimeout(() => {
      const index = this.backendInfoMessages.findIndex(
        (current) => current.id == id
      );
      this.backendInfoMessages.splice(index, 1);
    }, 15 * 1000);
  }

  public addBackEndMessage(backEndAnswer: ApiResponseWithputPagingSingle) {
    if (backEndAnswer.errorMessages.length > 0) {
      this.addListError(backEndAnswer.errorMessages);
    }
    if (backEndAnswer.hiddenMessages.length > 0) {
      this.addListWarning(backEndAnswer.hiddenMessages);
    }
    if (backEndAnswer.informationMessages.length > 0) {
      this.addListInfo(backEndAnswer.informationMessages);
    }
  }

  public addException(error: any, isJson: boolean): void {
    const id = this.guid.NewGuid();
    if (isJson) {
      var test = JSON.stringify(error);
      var test = test.replaceAll(`":`, `": `);
      this.errorMessages.push(
        new LoggingModel(id, JSON.stringify(error).replaceAll(`":`, `": `))
      );
    } else {
      this.errorMessages.push(new LoggingModel(id, error.message));
    }

    this.logWith(
      this.logLevel.Error,
      JSON.stringify(error).replaceAll(`":`, `": `)
    );

    setTimeout(() => {
      this.deleteItemError(id);
    }, 120 * 1000);
  }

  public addRequestLog(
    headers: any,
    apiRequest: ApiRequestModel,
    finalUrl: string,
    methodName: string
  ) {
    if (apiRequest.body==null) {
      console.log(
        `%cSend Request On "${methodName}" Method \n\t\tURL: ${finalUrl} `, 'color: blue'
      );
    }else{
      console.log(
        `%cSend Request On "${methodName}" Method \n\t\tURL: ${finalUrl} \n\t\t Body : \n${JSON.stringify(apiRequest.body, null, 2)}`, 'color: blue'
      );
    }
  }

  public addResponseLog(url: string, result: any, methodName: string) {
    var jsonResult = JSON.stringify(result);

    if (result==null) {
      console.log(`%cGet Response On "${methodName}" Method \n\t\tURL : ${url}\n\t\t No Result`, 'color: #05a125');
    }else{
      console.log(`%cGet Response On "${methodName}" Method \n\t\tURL : ${url}\n\t\t Body :\n${JSON.stringify(result, null, 2)}`, 'color: #05a125');
    }
    // this.addLog(
    //   `get Response with mehotdName: ${methodName}
    //     url:${url}
    //     result:
    //     ${jsonResult}
    //     `,
    //   this.logLevel.res
    // );
  }

  private logWith(level: any, msg: any): void {
    if (msg == null || msg == '') {
      return;
    }
    if (msg instanceof String == false) {
      msg = JSON.stringify(msg);
    }

    switch (level) {
      case this.logLevel.None:
        return console.log(msg);
      case this.logLevel.Info:
        return console.info('%c' + msg, 'color: #6495ED');
      case this.logLevel.Warn:
        return console.warn('%c' + msg, 'color: #FF8C00');
      case this.logLevel.Error:
        return console.error('%c' + msg, 'color: #DC143C');
      case this.logLevel.req:
        return console.info('%c' + msg, 'color: #3973ac');
      case this.logLevel.res:
        return console.info('%c' + msg, 'color: #aa4bfd');

      default:
        console.debug(msg);
    }
  }

  public clearInfo() {
    this.infoMessages = [];
  }

  public clearWarning() {
    this.warningMessages = [];
  }

  public clearError() {
    this.errorMessages = [];
  }

  public clearChangePage(){
    // this.infoMessages=this.infoMessages.slice(0);
    // this.infoJsonMessages=this.infoJsonMessages.slice(0);
    // this.warningMessages=this.warningMessages.slice(0);
    // this.warningJsonMessages=this.warningJsonMessages.slice(0);
    // this.errorMessages=this.errorMessages.slice(0);
    // this.errorJsonMessages=this.errorJsonMessages.slice(0);
    // this.backendErrorMessages=this.backendErrorMessages.slice(0);
    // this.backendWarningMessages=this.backendWarningMessages.slice(0);
    // this.backendInfoMessages=this.backendInfoMessages.slice(0);

    this.infoMessages=[]
    this.infoJsonMessages=[]
    this.warningMessages=[]
    this.warningJsonMessages=[]
    this.errorMessages=[]
    this.errorJsonMessages=[]
    this.backendErrorMessages=[]
    this.backendWarningMessages=[]
    this.backendInfoMessages=[]
  }

  public deleteItemInfo(id: string) {
    const index = this.infoMessages.findIndex((current) => current.id == id);
    this.infoMessages.splice(index, 1);
  }

  public deleteItemWarning(id: string) {
    const index = this.warningMessages.findIndex((current) => current.id == id);
    this.warningMessages.splice(index, 1);
  }

  public deleteItemError(id: string) {
    const index = this.errorMessages.findIndex((current) => current.id == id);
    this.errorMessages.splice(index, 1);
  }
}
